export default __webpack_public_path__ + "static/media/m.1a3bafe4.png";